<coreui-modal modalWidth="40" #saveAsNewDefinitionOnVersionChange>
  <!--
    This modal is used when another user has already updated the definition
    and the current user has made their own changes to the definition.
  -->
  <ng-template #titleTemplate>
    New Audience Definition
  </ng-template>
  <ng-template #titleCloseButtonTemplate>
    <button type="button" (click)="saveAsNewDefinitionOnVersionChange.hide()" coreUIButton="icon-large">
      <i coreUIIcon="close"></i>
    </button>
  </ng-template>
  <ng-template #contentTemplate>
    <input [(ngModel)]="builderService.audience.displayName" coreUIInput placeholder="New Audience Definition"
      autocomplete="off" />
  </ng-template>
  <ng-template #buttonsTemplate>
    <button coreUIButton="text-primary">
      Save
    </button>
  </ng-template>
</coreui-modal>
<div class="root-container">
  <div class="top-container">
    <coreui-breadcrumbs>
      <a [routerLink]="audienceDefinitionRouter" coreUIBreadcrumbLink>Definitions</a>
      <span coreUIBreadcrumbSlash *ngIf="audienceDefinitionName"></span>
      <span coreUIBreadcrumbEnd>{{audienceDefinitionName}}</span>
    </coreui-breadcrumbs>
    <h1 class="audienceName">{{audienceDefinitionName}}</h1>
    <div class="stepWizard">
      <coreui-step-wizard
        wizardStyle="ordered"
        #orderedWizard
        (change)="onStepChange($event)"
        (next)="onNextStepChange($event)"
        (previous)="onPreviousStepChange($event)"
      >
        <coreui-step
          [status]="isSetUpComplete ? 'verified' : 'enabled'"
          label="1. Definition Setup"
          [active]=true
          #orderedFirstStep
        >
        </coreui-step>
        <coreui-step
          [status]="isSetUpComplete ? 'enabled' : 'disabled'"
          [label]="isProductTypeDcdp ? '2. Define Criteria' : '2. Audience Selection'"
          #orderedLastStep
        >
        </coreui-step>
      </coreui-step-wizard>
    </div>
    <div *ngIf="currentIndex === 0">
      <lib-audience-builder-setup *ngIf="!isProductTypeDcdp" (setUpSaved)="moveToAudienceSelectionStep()"
        [audienceForm]="audienceForm" (setUpAndContinue)="builderSetupEvent($event)"></lib-audience-builder-setup>
      <lib-new-audience-builder-setup #audienceBuilderSetup *ngIf="isProductTypeDcdp"
        [isNewCriteriaSelectionEnabled]="isNewCriteriaSelectionEnabled" (setUpSaved)="moveToAudienceSelectionStep()"
        [audienceForm]="audienceForm" (setUpAndContinue)="builderSetupEvent($event)"></lib-new-audience-builder-setup>
    </div>
    <div *ngIf="currentIndex === 1">
      <div *ngIf="!isNewCriteriaSelectionEnabled;else showNewCriteriaSelectionFlow">
        <lib-audience-selection class="audienceSelection" [audienceForm]="audienceForm"></lib-audience-selection>
        <div class="stepWizardButtonGroup" coreUIGrid="standard">
          <div class="spacer" [coreUIGridItem]="4"></div>
          <div class="buttons" [coreUIGridItem]="8">
            <div coreUIButtonGroup class="submitAction">
              <button type="button" coreUIButton="icon-large" withBorder (click)="moveToAudienceSetup()"><i
                  coreUIIcon="arrowLeft" aria-label="Previous"></i></button>
              <button coreUIButton (click)="audienceDefSaved.emit({ audienceQueryCaseInsensitive })">Submit</button>
              <button coreUIButton="text-primary" (click)="cancel()">{{'Discard'}}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <ng-container *ngIf="isNewCriteriaSelectionEnabled">
    <div class="bottom-container">
      <ng-container *ngTemplateOutlet="newCriteriaSelectionFlowFooter"></ng-container>
    </div>
  </ng-container>
</div>
<ng-template #showNewCriteriaSelectionFlow>
  <lib-criteria #newCriteriaSelectionFlow [activeDedupeType]="audienceForm?.get('dedupeType')?.value"
    [isEdit]="true" [disableRunCount]="true"></lib-criteria>
</ng-template>

<ng-template #newCriteriaSelectionFlowFooter>
  <div class="footer-container" *ngIf="isProductTypeDcdp">
    <div class="footer-left-container">
      <button type="button" coreUIButton="icon-large" withBorder (click)="onFooterBackAction()">
        <i coreUIIcon="arrowLeft"></i>
      </button>
    </div>
    <div class="footer-right-container">
      <button type="button" coreUIButton="text-primary" (click)="onFooterDiscardAction()">Discard</button>
      <button type="button" coreUIButton="primary" (click)="onSaveOrSubmitAction()"> {{ isSetUpComplete ? 'Submit' : 'Save & Continue' }}</button>
    </div>
  </div>
</ng-template>